import ScreenshotCarousel, { ScreenshotItem } from './ScreenshotCarousel';

const ControllerScreenshotsGallery = () => {
  const screenshots: ScreenshotItem[] = [
    {
      src: '/screenshots/app-controller/controller-1.PNG',
      alt: 'Écran d\'accueil - Scan de plaque d\'immatriculation',
      title: 'Étape 1 : Accueil et Scan',
      description: 'Accédez rapidement à l\'interface de scan de plaques. L\'application est optimisée pour une utilisation sur le terrain avec une interface sombre et des boutons facilement accessibles. Démarrez un contrôle en un clic. Utilisez la caméra pour scanner automatiquement les plaques d\'immatriculation tunisiennes. La reconnaissance OCR avancée avec MLKit détecte et saisit instantanément le numéro de plaque sans intervention manuelle.',
      step: 'Accès rapide'
    },
    {
      src: '/screenshots/app-controller/controller-2.PNG',
      alt: 'Scan de plaque manuel',
      title: 'Étape 2 : Scan Automatique ou Manuel',
      description: 'Vous pouvez soit scanner automatiquement les plaques d\'immatriculation tunisiennes avec la caméra, soit saisir manuellement le numéro de plaque en cas de difficulté de reconnaissance ou manque de lumière.',
      step: 'Reconnaissance automatique'
    },
    {
      src: '/screenshots/app-controller/controller-3.PNG',
      alt: 'Vérification du ticket',
      title: 'Étape 3 : Vérification',
      description: 'Consultez instantanément les informations du ticket associé au véhicule : durée restante, parking utilisé, véhicule concerné et statut de validité. Toutes les informations essentielles en un coup d\'œil.',
      step: 'Vérification du ticket'
    },
    {
      src: '/screenshots/app-controller/controller-4.PNG',
      alt: 'Historique et statistiques',
      title: 'Étape 4 : Suivi et Historique',
      description: 'Consultez l\'historique complet de vos contrôles, les statistiques de la journée et les violations détectées. Navigation intuitive pour retrouver rapidement n\'importe quel contrôle effectué.',
      step: 'Gestion des contrôles'
    },
  ];

  return (
    <ScreenshotCarousel
      screenshots={screenshots}
      variant="mobile"
      colorScheme={{
        badge: 'bg-green-100 text-green-800',
        activeBadge: 'bg-green-600',
        border: 'border-green-600',
        ring: 'ring-green-200',
        indicator: 'bg-green-600',
      }}
      thumbnailTitle="Parcours complet en 4 étapes"
      showThumbnails={false}
      autoplay={false}
    />
  );
};

export default ControllerScreenshotsGallery;
